import React from 'react';
import { credentials, education } from '../data/portfolio';
import { Label } from './Label';
export function Credentials() {
  return <section id="credentials" aria-labelledby="credentials-heading" className="scroll-mt-20 bg-ink-900 px-6 py-20 md:px-10 md:py-24" data-id="element-95" data-mp="2qjzm33i00535">
      <div className="mx-auto w-full max-w-edge" data-id="element-96" data-mp="2zcb1lubkq84c">
        <Label data-id="element-97" data-mp="2zdkzojiffgaz">Credentials</Label>
        <h2 id="credentials-heading" className="sr-only" data-id="element-98" data-mp="2bmytyyvwa845">
          Qualifications and education
        </h2>

        <div className="mt-12 grid gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-99" data-mp="27m55a3amopa7">
          <div data-id="element-100" data-mp="27nztprl3yzj1">
            <h3 className="text-[0.8rem] uppercase tracking-[0.24em] text-fog" data-id="element-101" data-mp="2ll4v3e9vna7y">
              Professional qualifications
            </h3>
            <dl className="mt-6 border-t border-white/20" data-id="element-102" data-mp="2gljvr2qsozup">
              {credentials.map(credential => <div key={credential.title} className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-1 border-b border-white/10 py-4" data-id="element-103" data-mp="tm9llyk9479">
                  <dt className="text-base text-paper" data-id="element-104" data-mp="3edz45vnu0q62">{credential.title}</dt>
                  <dd className="text-[0.85rem] text-stone" data-id="element-105" data-mp="3jck4dv3339ui">{credential.detail}</dd>
                </div>)}
            </dl>
          </div>

          <div data-id="element-106" data-mp="3tbrem9eiuode">
            <h3 className="text-[0.8rem] uppercase tracking-[0.24em] text-fog" data-id="element-107" data-mp="3tbhqysgy8tav">
              Education &amp; academic appointments
            </h3>
            <dl className="mt-6 border-t border-white/20" data-id="element-108" data-mp="2vpk8gv2kknyx">
              {education.map(item => <div key={item.institution} className="flex flex-wrap items-baseline justify-between gap-x-8 gap-y-1 border-b border-white/10 py-4" data-id="element-109" data-mp="30ndgzurchu2d">
                  <dt className="text-base text-paper" data-id="element-110" data-mp="3ae8411cf0xov">{item.institution}</dt>
                  <dd className="text-[0.85rem] text-stone" data-id="element-111" data-mp="2cwq6r2tyiscn">
                    {item.programme} · {item.detail}
                  </dd>
                </div>)}
            </dl>
          </div>
        </div>
      </div>
    </section>;
}